import {EditPageComponent} from "./edit-page.component";
import {ChangeDetectorRef, Directive, HostBinding, ViewChild} from "@angular/core";
import {ReportGenerationService} from "../../report/report-generation.service";
import {FUIFormationType, FUIResponsiveService} from "@fedeltapointofsale/ui";

export enum PageContentMode {
    BASIC,
    DETAILED,
    CUSTOM1,
    CUSTOM2,
    CUSTOM3
}

export class EditPageState {
    contentMode: PageContentMode;
    advanced: boolean = false;

    constructor(contentMode: PageContentMode) {
        this.contentMode = contentMode;
    }
}

@Directive()
export abstract class AbstractEditPage {
    FUIFormationType = FUIFormationType;

    @ViewChild(EditPageComponent, {static: true}) editPageComponent: EditPageComponent;
    @HostBinding("style.display") private display: string = "flex";
    @HostBinding("style.width") private width: string = "100%";

    pageState: EditPageState = new EditPageState(PageContentMode.BASIC);

    constructor(protected changeDetectorRef: ChangeDetectorRef,
                protected responsiveService: FUIResponsiveService,
                protected hasDetailedMode: boolean = true) {
    }

    get showBasicContent(): boolean {
        return this.pageState.contentMode === PageContentMode.BASIC;
    }

    get showDetailedContent(): boolean {
        return this.pageState.contentMode === PageContentMode.DETAILED;
    }

    get showAdvancedContent(): boolean {
        return (!this.hasDetailedMode || this.pageState.contentMode === PageContentMode.DETAILED) && this.pageState.advanced;
    }

    get editParams(): any {
        return this.editPageComponent ? this.editPageComponent.editParams : undefined;
    }

    get reportGenerationService(): ReportGenerationService {
        return this.editPageComponent.reportGenerationService;
    }

    setContentMode(contentMode: PageContentMode): void {
        if (this.pageState.contentMode !== contentMode) {
            this.pageState.contentMode = contentMode;
            this.changeDetectorRef.detectChanges();
            this.responsiveService.emitWindowWidthChange();
        }
    }

    canDeactivate(): boolean {
        return this.editPageComponent ? !this.editPageComponent.editService.dirty : true;
    }

    updateValueAndValidity(formControlNames?: string[]): void {
        this.editPageComponent.editService.updateValueAndValidity(formControlNames);
    }

    markAsTouched(formControlNames: string[]): void {
        this.editPageComponent.editService.markAsTouched(formControlNames);
    }
}
